var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"chart"},[_c('VsLoader',{attrs:{"visible":!!_vm.itemCoverageTotals.isLoading}}),(_vm.chartData)?[_c('ItemCoverageChart',{attrs:{"chartData":_vm.chartData,"options":_vm.chartOptions,"height":_vm.height,"width":_vm.width,"styles":{
        maxWidth: '725px',
        margin: 'auto',
      }}})]:_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }